export const ASSETS = {
  logos: {
    pjsrs: "https://customer-assets.emergentagent.com/job_fceb2d2b-7ff2-4bdd-8da7-946d6f7ccffd/artifacts/1289hc4a_PJSRSR%20-Logo_Final.png",
    fit2fin: "https://customer-assets.emergentagent.com/job_pjsrs-landing/artifacts/9ew21uox_Fit2Fin%20-%20Final.png",
    cricstorylive: "https://customer-assets.emergentagent.com/job_pjsrs-landing/artifacts/sok0emuk_CricStoryLive_Final.png",
    salaryai: "https://customer-assets.emergentagent.com/job_pjsrs-landing/artifacts/s6z50tlb_SalaryAI_Final.png",
    crazycricket: "https://customer-assets-jt897jd0.emergentagent.net/job_pjsrs-landing/artifacts/36qdllpj_Crazy%20Cricket_Final.png",
  },
  images: {
    heroBg: "https://images.pexels.com/photos/7562087/pexels-photo-7562087.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    fit2finHero: "https://images.pexels.com/photos/4429141/pexels-photo-4429141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    fit2finFeature: "https://images.unsplash.com/photo-1508685096489-7aacd43bd3b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwcnVubmluZyUyMHNtYXJ0JTIwd2F0Y2h8ZW58MHx8fHwxNzgyMTQ3NjQ3fDA&ixlib=rb-4.1.0&q=85",
    cricstoryHero: "https://images.pexels.com/photos/32945758/pexels-photo-32945758.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    cricstoryFeature: "https://images.unsplash.com/photo-1750716413756-b66624b64ce4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwc3RhZGl1bSUyMGxpZ2h0cyUyMG5pZ2h0fGVufDB8fHx8MTc4MjE0NzY0Nnww&ixlib=rb-4.1.0&q=85",
  },
  contact: {
    email: "admin@pjsrs.com",
    domain: "www.pjsrs.com",
  },
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
